<template>
  <multiple_form
    :forms="forms"
    :edit="true"
    :editData="props.editData"
    :disabled="true"
    :submitBtn="false"
    :isScroll="false"
  />
</template>
<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  import multiple_form from '@/components/multiple_form'
  //初始化
  const props = defineProps({
    editData: Object,
    data: Array,
    idField: String,
  })
  const emit = defineEmits(['submit'])

  //表单
  const forms = computed(() => [
    {
      name: '基础信息',
      id: 'applicant_information',
      formItem: [
        {
          type: 'select',
          field: 'visit_area',
          label: '申请园区',
          storeOptions: 'areaType',
        },
        {
          type: 'input',
          field: 'visitor_company',
          label: '来访单位',
        },
        {
          type: 'input',
          field: 'license_plate',
          label: '车牌号码',
        },
        {
          type: 'select',
          field: 'license_plate_color',
          storeOptions: 'plateColorType',
          getName: true,
          label: '车牌颜色',
          required: false,
        },
        {
          type: 'input',
          field: 'total_mass',
          label: '车辆总质量KG(行驶证)',
        },
        {
          type: 'dateRange',
          startField: 'begin_time',
          endField: 'end_time',
          label: '来访时间',
        },
        {
          type: 'input',
          field: 'phone',
          label: '手机号码',
        },
      ],
    },
    {
      name: '相关文件',
      id: 'applicant_file',
      formItem: [
        {
          type: 'image',
          field: 'registry_img',
          label: '车辆信息登记表',
          required: false,
        },
        {
          type: 'image',
          field: 'business_license',
          label: '营业执照复印件',
          required: false,
        },
        {
          type: 'input',
          field: 'company_road_transport_number',
          label: '公司道路运输经营许可证字号',
          required: false,
        },
        {
          type: 'dateRange',
          startField: 'company_road_transport_validity_start',
          endField: 'company_road_transport_validity_end',
          label: '公司道路运输经营许可证有效期',
          required: false,
        },
        {
          type: 'image',
          field: 'company_road_transport_img',
          label: '公司道路运输经营许可证复印件',
          number: 20,
          required: false,
        },
        {
          type: 'image',
          field: 'legal_person_img',
          label: '法人身份证',
          number: 20,
          required: false,
        },
        {
          type: 'image',
          field: 'driver_info_img',
          label: '驾驶员的驾驶证、身份证及从业资格证',
          number: 20,
          required: false,
        },
        {
          type: 'image',
          field: 'supercargo_info_img',
          label: '押运员的身份证以及从业资格证',
          number: 20,
          required: false,
        },
        {
          type: 'image',
          field: 'vehicle_driving_permit_img',
          label: '行驶证（车头、挂车）',
          number: 20,
          required: false,
        },
        {
          type: 'input',
          field: 'road_transport_number',
          label: '道路运输证字号',
          required: false,
        },
        {
          type: 'dateRange',
          startField: 'road_transport_validity_start',
          endField: 'road_transport_validity_end',
          label: '道路运输证有效期',
          required: false,
        },
        {
          type: 'image',
          field: 'road_transport_img',
          label: '道路运输证（车头、挂车）',
          number: 20,
          required: false,
        },
        {
          type: 'image',
          field: 'compulsory_insurance_img',
          label: '强制险',
          number: 20,
          required: false,
        },
        {
          type: 'image',
          field: 'commercial_insurance_img',
          label: '商业险',
          number: 20,
          required: false,
        },
        {
          type: 'image',
          field: 'carrier_liability_insurance_img',
          label: '道路危险货物承运人责任保险',
          number: 20,
          required: false,
        },
        {
          type: 'input',
          field: 'tank_number',
          label: '罐体编号',
          required: false,
        },
        {
          type: 'input',
          field: 'tank_volume',
          label: '罐体容积',
          required: false,
        },
        {
          type: 'input',
          field: 'tank_medium_range',
          label: '罐体适装介质范围',
          required: false,
        },
        {
          type: 'dateRange',
          startField: 'tank_report_validity_start',
          endField: 'tank_report_validity_end',
          label: '罐检报告有效期',
          required: false,
        },
        {
          type: 'image',
          field: 'report_or_instruction_img',
          label: '罐检报告或产品图片、产品标签图片以及车尾照片',
          number: 20,
          required: false,
        },
        {
          type: 'image',
          field: 'letter_commitment_img',
          label: '重点运输单位承诺书',
          number: 20,
          required: false,
        },
        {
          //type: 'fileUpload',
          type: 'image',
          field: 'gps_instruction_img',
          label: 'GPS接入文档',
          number: 20,
          required: false,
        },
      ],
    },
  ])
</script>
